const theme = {
  // "Name that Color" names
  colors: {
    // Text Colors
    white: '#fff',
    black: '#000',
    green: '#00FF00',
  },
  fonts: {
    face: {
      // eslint-disable-next-line quotes
      primary: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    },
    scale: {
      // Based on Material design typography scale, adjust as needed
      // fontSize: rem, letterSpacing: rem
      headline1: {
        fontSize: { tablet: 192, mobile: 192 },
        lineHeight: { tablet: 1, mobile: 1 },
        fontWeight: 400,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      headline2: {
        fontSize: { tablet: 120, mobile: 120 },
        lineHeight: { tablet: 1.14, mobile: 1.14 },
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      headline3: {
        fontSize: { tablet: 96, mobile: 96 },
        lineHeight: { tablet: 1.42, mobile: 1.42 },
        fontWeight: 400,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      headline4: {
        fontSize: { tablet: 68, mobile: 68 },
        lineHeight: { tablet: 1.83, mobile: 1.83 },
        fontWeight: 700,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      headline5: {
        fontSize: { tablet: 48, mobile: 48 },
        lineHeight: { tablet: 1.53, mobile: 1.53 },
        fontWeight: 600,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
      },
      headline6: {
        fontSize: { tablet: 40, mobile: 40 },
        lineHeight: { tablet: 1.6, mobile: 1.6 },
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      subtitle1: {
        fontSize: { tablet: 32, mobile: 32 },
        lineHeight: { tablet: 2, mobile: 2 },
        fontWeight: 600,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      subtitle2: {
        fontSize: { tablet: 28, mobile: 28 },
        lineHeight: { tablet: 2, mobile: 2 },
        fontWeight: 700,
        letterSpacing: 0,
        textTransform: 'uppercase',
      },
      body1: {
        fontSize: { tablet: 32, mobile: 32 },
        lineHeight: { tablet: 1.5, mobile: 1.5 },
        fontWeight: 400,
        letterSpacing: 0,
        textTransform: 'none',
      },
      body2: {
        fontSize: { tablet: 28, mobile: 28 },
        lineHeight: { tablet: 1.5, mobile: 1.5 },
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: 'none',
      },
      button: {
        fontSize: { tablet: 28, mobile: 28 },
        lineHeight: { tablet: 2.28, mobile: 2.28 },
        fontWeight: 800,
        letterSpacing: 0.078125,
        textTransform: 'uppercase',
      },
      footer: {
        fontSize: { tablet: 24, mobile: 24 },
        lineHeight: { tablet: 1.1, mobile: 1.1 },
        fontWeight: 400,
        letterSpacing: 0,
        textTransform: 'none',
      },
      caption: {
        fontSize: { tablet: 24, mobile: 24 },
        lineHeight: { tablet: 2.28, mobile: 2.28 },
        fontWeight: 600,
        letterSpacing: 0,
        textTransform: 'none',
      },
      input: {
        fontSize: { tablet: 24, mobile: 24 },
        lineHeight: { tablet: 1.78, mobile: 1.78 },
        fontWeight: 600,
        letterSpacing: 0,
        textTransform: 'none',
      },
    },
  },
} as const;

// Aliases
export const { colors, fonts } = theme;

export default theme;
